"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var fontSize = exports.fontSize = {
  type: "select",
  options: [{ label: "10", value: "10px" }, { label: "11", value: "11px" }, { label: "12", value: "12px" }, { label: "13", value: "13px" }, { label: "14", value: "14px" }, { label: "15", value: "15px" }, { label: "16", value: "16px" }, { label: "17", value: "17px" }, { label: "18", value: "18px" }, { label: "19", value: "19px" }, { label: "20", value: "20px" }, { label: "22", value: "22px" }, { label: "24", value: "24px" }, { label: "26", value: "26px" }, { label: "28", value: "28px" }, { label: "30", value: "30px" }]
};

var transform = exports.transform = {
  type: "select",
  options: [{ label: "Capitalize", value: "capitalize" }, { label: "Uppercase", value: "uppercase" }, { label: "Lowercase", value: "lowercase" }]
};
var fontWeight = exports.fontWeight = {
  type: "select",
  options: [{ label: "Light", value: "300" }, { label: "Normal", value: "400" }, { label: "Medium", value: "500" }, { label: "Bold", value: "600" }]
};

var logoWidth = exports.logoWidth = {
  type: "select",
  options: [{ label: "140", value: "140px" }, { label: "150", value: "150px" }, { label: "180", value: "180px" }, { label: "200", value: "200px" }]
};

var logoHeight = exports.logoHeight = {
  type: "select",
  options: [{ label: "100", value: "100px" }, { label: "110", value: "110px" }, { label: "120", value: "120px" }, { label: "130", value: "130px" }]
};

var radius = exports.radius = {
  type: "select",
  options: [{ label: "none", value: "0" }, { label: "5", value: "5px" }, { label: "10", value: "10px" }, { label: "15", value: "15px" }, { label: "20", value: "20px" }, { label: "25", value: "25px" }, { label: "30", value: "30px" }]
};